import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import additionalDataReducer from './additionalDataSlice';
import errorSlice from './errorSlice';
import flowReducer from './flowSlice';
import navigationReducer from './navigationSlice';

const resettableRootReducer = (state: ReturnType<typeof rootReducer> | undefined, action: AnyAction) => {
  if (action.type === 'store/reset') {
    document.cookie = `instanceId=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    return rootReducer(undefined, action);
  }

  return rootReducer(state, action);
};

const rootReducer = combineReducers({
  navigationdata: navigationReducer,
  flowdata: flowReducer,
  errorState: errorSlice,
  additionalData: additionalDataReducer,
});

// One store per request on the server and one per browser session, so state never leaks between users
export const makeStore = () =>
  configureStore({
    reducer: resettableRootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
    devTools: process.env.NEXT_PUBLIC_ENV !== 'production',
  });

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<typeof rootReducer>;
